import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { cn } from '@lyearn/style';
import { Stack, Typography } from '@lyearn/ui';

import { FrequencyComponentProps } from '../../types';
import FrequencyInput from '../InputComponents/Frequency';
import TimeOfDay from '../InputComponents/TimeOfDay';
import WeekdaysInput from '../InputComponents/Weekdays';

const TIME_OF_DAY_CLASSES = { label: 'ms-6 me-12' };

const Weekly = ({
  value,
  onChange,
  hideTimeSelection,
  disabled,
  allowedFrequencies,
  errorConfig,
  size,
}: FrequencyComponentProps) => {
  const { t } = useTranslation();

  return (
    <Stack direction="col" gapY={16}>
      <Stack justifyContent="between">
        <FrequencyInput
          allowedFrequencies={allowedFrequencies}
          disabled={disabled}
          size={size}
          value={value}
          onChange={onChange}
        />
        <Typography
          className={cn('mx-12 my-auto', { 'pb-24': Boolean(errorConfig?.daysOfWeek) })}
          variant={size === 'medium' ? 'body-short-02' : 'body-short-01'}>
          {t('On')}
        </Typography>
        <WeekdaysInput
          disabled={disabled}
          error={errorConfig?.daysOfWeek}
          size={size}
          value={value}
          onChange={onChange}
        />
      </Stack>
      {hideTimeSelection ? null : (
        <TimeOfDay
          classes={TIME_OF_DAY_CLASSES}
          disabled={disabled}
          size={size}
          value={value}
          onChange={onChange}
        />
      )}
    </Stack>
  );
};

export default Weekly;
